import { Icon } from "@iconify/react";

export function NextArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      onClick={onClick}
      className="
        absolute right-2 top-1/2 -translate-y-1/2 z-20
        bg-black/40 dark:bg-black/50
        backdrop-blur-md
        p-3 rounded-full cursor-pointer
        shadow-lg shadow-black/30
        hover:bg-primary hover:shadow-primary/40
        transition-all duration-300
        group
      "
    >
      <Icon
        icon="ion:chevron-forward"
        width={26}
        className="text-white group-hover:text-white"
      />
    </div>
  );
}

export function PrevArrow(props: any) {
  const { onClick } = props;
  return (
    <div
      onClick={onClick}
      className="
        absolute left-2 top-1/2 -translate-y-1/2 z-20
        bg-black/40 dark:bg-black/50
        backdrop-blur-md
        p-3 rounded-full cursor-pointer
        shadow-lg shadow-black/30
        hover:bg-primary hover:shadow-primary/40
        transition-all duration-300
        group
      "
    >
      <Icon
        icon="ion:chevron-back"
        width={26}
        className="text-white group-hover:text-white"
      />
    </div>
  );
}
